const years = [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];

const flattenValues = (values, prefix) => {
  const result = {};

  if (values['1']) {
    for (const year of years) {
      result[`${prefix}${year}B`] = values['1'][year];
    }
  }

  if (values['2']) {
    for (const year of years) {
      result[`${prefix}${year}S`] = values['2'][year];
    }
  }

  return result;
};

const rowErrorCheck = (row, targetField, planField) => {
  const rowTargetField = row[targetField]!=null ? row[targetField]?.value :0
  return !!(row[planField]!=null && (rowTargetField < row[planField]?.value));
}

const getErrors = (row) => {
  const result = {};

  for (const year of years) {
    result[`planApproved${year}BError`] = rowErrorCheck(row, `planApproved${year}B`, `plan${year}B`);
    result[`planApproved${year}SError`] = rowErrorCheck(row, `planApproved${year}S`, `plan${year}S`);
    result[`fact${year}BError`] = rowErrorCheck(row, `fact${year}B`, `plan${year}B`);
    result[`fact${year}SError`] = rowErrorCheck(row, `fact${year}S`, `plan${year}S`);
  }

  return result;
};

export const getErrorsInTotal = (row, years) =>{
  const result = {};

  for (const year of years) {
    result[`plan${year}ApprovedTotalBError`] = rowErrorCheck(row, `plan${year}ApprovedTotalB`, `plan${year}TotalB`);
    result[`plan${year}ApprovedTotalSError`] = rowErrorCheck(row, `plan${year}ApprovedTotalS`, `plan${year}TotalS`);
    result[`fact${year}TotalBError`] = rowErrorCheck(row, `fact${year}TotalB`, `plan${year}TotalB`);
    result[`fact${year}TotalSError`] = rowErrorCheck(row, `fact${year}TotalS`, `plan${year}TotalS`);
  }
  return result;

}

export const mapDtoToTable = (dto) => dto
  .map((d) => ({
    ...d,
    ...flattenValues(d.plans, 'plan'),
    ...flattenValues(d.approvedPlans, 'planApproved'),
    ...flattenValues(d.facts, 'fact'),
  }))
  .map((d) => ({
    ...d,
    ...getErrors(d),
  }));
